import axios from '@/api/config';

const saleCenter = {
  getFlashSaleGoodsList(data) {
    return axios.get(
      `${process.env.BASE_URL}/schoolPage/getFlashSaleGoodsList`, {
        params: data
      }
    );
  },
  deleteActivity(data) {
    return axios.delete(`${process.env.BASE_URL}/activity/deleteActivity`, {
      data: data
    });
  },
  activityPageList(data) {
    return axios.post(`${process.env.BASE_URL}/activity/pageList`, data);
  },
  addActivity(data) {
    return axios.post(`${process.env.BASE_URL}/activity/addActivity`, data);
  },
  updateActivity(data) {
    return axios.put(`${process.env.BASE_URL}/activity/updateActivity`, data);
  },
  getActivityById(data) {
    return axios.get(`${process.env.BASE_URL}/activity/getActivity`, {
      params: data
    });
  },
}

export default saleCenter;



// WEBPACK FOOTER //
// ./src/api/saleCenter.js